import localize from "../../../../common/localize";
import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";
import StateChangeTimeline from "../StateChangeTimeline";

export default function ReportStatusChangeData({
  eventDetailData,
  statusChangeStoryTime,
  hideSignatures,
  isOriginal,
  formFormat,
  hideModificationDate,
}) {
  return (
    <div>
      <ReportSectionTitle title={localize.status_historical} />

      <div>
        <StateChangeTimeline
          eventModel={eventDetailData}
          timelineData={statusChangeStoryTime?.Data || []}
          firstStatusChange={
            statusChangeStoryTime?.Data?.length > 0
              ? statusChangeStoryTime.Data[0]
              : undefined
          }
          isForReport
          hideSignatures={hideSignatures}
          isOriginal={isOriginal}
          formResultsFormatting={formFormat}
          hideModificationDate={hideModificationDate}
        />
      </div>
    </div>
  );
}
